import {useEffect, useState} from 'react'
import chroma from 'chroma-js'
import {theme} from '../theme'
import {useTrackColors} from './useTrackColors'

export const useTrackTheme = () => {
  const [state, setState] = useState(theme)
  const colors = useTrackColors()

  useEffect(() => {
    if (colors) {
      const primary = chroma(colors.color)
      const secondary = chroma(colors.alternativeColor)
      const background = chroma(colors.backgroundColor)

      setState(t => ({
        ...t,
        colors: {
          primary: colors.color,
          primaryLight: primary.brighten().hex(),
          primaryDark: primary.darken().hex(),
          secondary: colors.alternativeColor,
          secondaryLight: secondary.brighten().hex(),
          secondaryDart: secondary.darken().hex(),
          background: colors.backgroundColor,
          backgroundLight: background.brighten().hex(),
          backgroundDark: background.darken().hex()
        }
      }))
    }
  }, [colors])

  return state
}
